export var defaultCabinInputValues = {
    adults: 1,
    youth: 0,
    child: 0,
    infant: 0,
    cabin: 'economy',
};
